import { useState } from "react";
import { toast } from "sonner";
import { Eye, Send, Loader2, AlertTriangle } from "lucide-react";
import api from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

export const SeasonGapWarning = ({ rows }) => {
  const gaps = rows.filter((r) => !r.is_past && !(r.candidates || []).length);
  if (!gaps.length) return null;
  return (
    <div className="flex gap-3 p-4 rounded-xl border" style={{ backgroundColor: "#FFF3CD", borderColor: "#D4A017", color: "#5C4300" }} data-testid="potw-season-warning">
      <AlertTriangle className="w-5 h-5 shrink-0 mt-0.5" />
      <div className="text-sm">
        <div className="font-semibold">Keine passende Pflanze in Saison – an diesen Wochen wird nichts verschickt:</div>
        <div className="mt-1" data-testid="potw-season-warning-weeks">{gaps.map((r) => `KW ${r.iso_week} (${r.monday})`).join(", ")}</div>
        <div className="mt-1 opacity-80">Tipp: Pflanze mit passender Saison als heimisch markieren oder ein echtes Foto hochladen.</div>
      </div>
    </div>
  );
};

export const PotwTestActions = ({ weekKey, disabled, to }) => {
  const [busy, setBusy] = useState("");
  const [preview, setPreview] = useState(null);

  const openPreview = async () => {
    setBusy("preview");
    try {
      const { data } = await api.get(`/admin/weekly-plants/${weekKey}/preview`);
      setPreview(data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Vorschau fehlgeschlagen");
    } finally {
      setBusy("");
    }
  };

  const sendTest = async () => {
    setBusy("send");
    try {
      const { data } = await api.post(`/admin/weekly-plants/${weekKey}/test-send`, { to: (to || "").trim() });
      toast.success(`Test-Mail „${data.plant_name}“ an ${data.to} verschickt`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Test-Mail fehlgeschlagen");
    } finally {
      setBusy("");
    }
  };

  const btn = "flex-1 inline-flex items-center justify-center gap-1 px-2 py-1.5 rounded-full border text-xs transition-colors hover:bg-[var(--wp-cream)] disabled:opacity-40";
  return (
    <div className="flex gap-2">
      <button onClick={openPreview} disabled={disabled || !!busy} className={btn} style={{ borderColor: "var(--wp-border)" }} data-testid={`potw-preview-btn-${weekKey}`}>
        {busy === "preview" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Eye className="w-3.5 h-3.5" />} Vorschau
      </button>
      <button onClick={sendTest} disabled={disabled || !!busy} className={btn} style={{ borderColor: "var(--wp-border)" }} data-testid={`potw-test-send-btn-${weekKey}`}>
        {busy === "send" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Send className="w-3.5 h-3.5" />} {to ? "Test senden" : "Test an mich"}
      </button>
      <Dialog open={!!preview} onOpenChange={(o) => !o && setPreview(null)}>
        <DialogContent className="max-w-2xl" data-testid="potw-preview-dialog">
          <DialogHeader>
            <DialogTitle data-testid="potw-preview-subject">{preview?.subject}</DialogTitle>
          </DialogHeader>
          <iframe title="Newsletter-Vorschau" srcDoc={preview?.html || ""} className="w-full h-[70vh] rounded-lg border" style={{ borderColor: "var(--wp-border)" }} data-testid="potw-preview-iframe" />
        </DialogContent>
      </Dialog>
    </div>
  );
};
